import React from 'react';
import { useStudentTheme } from '@context/StudentThemeContext';

/**
 * Subtle, ambient background for the Student Portal — a few large, heavily
 * blurred gradient blobs drifting slowly. Pure CSS animation (transform +
 * opacity only, see studentDarkTheme.scss) so it stays cheap on mobile and
 * is trivially paused for prefers-reduced-motion. Renders in both themes
 * with theme-appropriate intensity; purely decorative (aria-hidden, no
 * pointer events) so it never interferes with content or a11y.
 */
const StudentAnimatedBackground: React.FC = () => {
    const { theme } = useStudentTheme();
    const isDark = theme === 'dark';

    return (
        <div className="sp-bg-layer pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden="true">
            <div
                className="sp-blob sp-blob-a -top-24 left-[10%] h-[420px] w-[420px]"
                style={{
                    background: isDark
                        ? 'radial-gradient(circle, oklch(0.55 0.2 264 / 0.35), transparent 70%)'
                        : 'radial-gradient(circle, oklch(0.72 0.15 250 / 0.16), transparent 70%)',
                }}
            />
            <div
                className="sp-blob sp-blob-b top-1/3 -right-32 h-[480px] w-[480px]"
                style={{
                    background: isDark
                        ? 'radial-gradient(circle, oklch(0.5 0.2 295 / 0.28), transparent 70%)'
                        : 'radial-gradient(circle, oklch(0.62 0.15 295 / 0.1), transparent 70%)',
                }}
            />
            <div
                className="sp-blob sp-blob-c bottom-[-10%] left-[28%] h-[380px] w-[380px]"
                style={{
                    background: isDark
                        ? 'radial-gradient(circle, oklch(0.45 0.18 220 / 0.25), transparent 70%)'
                        : 'radial-gradient(circle, oklch(0.75 0.1 220 / 0.09), transparent 70%)',
                }}
            />
        </div>
    );
};

export default StudentAnimatedBackground;
